module.exports = __webpack_public_path__ + "img/pitch.18f7ccbd.svg";